import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import styled from 'styled-components';

import InputField from 'dashboard/components/FormControls/InputField';
import Button from 'design-system/components/Button';
import { HStack } from 'design-system/components/Stack';
import { isRequired, withMessage } from 'lib/utils/formValidation';

const validate = {
  identificationNumber: withMessage('Please enter an ID number', isRequired),
};

const InputGrid = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr 40px;
  column-gap: 40px;
`;

const StyledInputField = styled(InputField)`
  grid-column: 2 / -1;
`;

const ButtonGrid = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
`;

interface FormAccountIdPropertyProps {
  handleCancel: () => void;
}

const FormAccountIdProperty = ({
  handleCancel,
  handleSubmit,
  submitting,
}: FormAccountIdPropertyProps &
  InjectedFormProps<AccountIdPropertyFormData, FormAccountIdPropertyProps>) => {
  return (
    <form onSubmit={handleSubmit}>
      <InputGrid>
        <div>
          {/* Need another element for the grid to line up with the table this form is rendered in */}
        </div>
        <Field
          component={StyledInputField}
          name='identification-number'
          type='text'
          validate={validate.identificationNumber}
          disabled={submitting}
          autoFocus={true}
        />
      </InputGrid>
      <HStack equal={true}>
        <div></div>
        <ButtonGrid>
          <Button type='submit' disabled={submitting} isPending={submitting} width='auto'>
            Update
          </Button>
          <Button
            id='account-property__cancel'
            disabled={submitting}
            variant='basic'
            width='auto'
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </ButtonGrid>
      </HStack>
    </form>
  );
};

export interface AccountIdPropertyFormData {
  'identification-number': string;
  'identification-class': string;
  'issuing-country': string;
}

export default reduxForm<AccountIdPropertyFormData, FormAccountIdPropertyProps>({
  form: 'FormAccountIdProperty',
  enableReinitialize: true,
})(FormAccountIdProperty);
